import React, { Component, Fragment } from 'react'
import { Link, Redirect } from 'react-router-dom'

import { Button } from '@driftt/dds'
import { Div, Input, NavigationHeader } from '@driftt/tide-core'

import { startImport } from 'api/imports'

import AccountsImportMappings from 'components/AccountsImportMappings'
import FileUpload from 'components/FileUpload'
import ImportInstructions from 'components/ImportInstructions'

import './style.css'

class CSVImport extends Component {

  state = {
    upload: null,
    mappings: null,
    impor: null,
    allTargeted: true
  }

  onClear = () => {
    this.setState({
      upload: null,
      mappings: null,
      impor: null
    })
  }

  onUpload = upload => {
    this.setState({
      upload: upload
    })
  }

  onUpdateMappings = mappings => {
    this.setState({
      mappings: mappings
    })
  }

  onStartImport = async () => {
    const { mappings, upload, allTargeted } = this.state
    
    try {
      const { data:impor } = await startImport({
        fileID: upload.fileID,
        headerMap: mappings,
        targeted: allTargeted,
        fileName: upload.fileName
      })
      this.setState({ impor: impor })
    } catch (err) {
      console.log(err)
    }
  }

  onChangeTarget = () => {
    this.setState(prevState => ({
      allTargeted: !prevState.allTargeted
    }))
  }

  render() {
    const { upload, mappings, impor, allTargeted } = this.state

    if (!!impor) {
      return <Redirect to="/imports" />
    }

    return (
      <Fragment>
        <NavigationHeader title="Import accounts">
          <Link to={`/imports/csv`} className="new-import--actions--log-link">Import logs</Link>
          <Button variant="secondary" onClick={() => window.open('/imports', '_self')}>Cancel</Button>
          <Button onClick={this.onStartImport} disabled={!mappings}>Finish</Button>
        </NavigationHeader>
        <Div className="new-import">
          <FileUpload onUpload={this.onUpload} onClear={this.onClear} />
          <ImportInstructions />
          <Div className="import--mapping-container">
            {!!upload &&
              <Div className="new-import--targeted">
                <Input type="checkbox" checked={allTargeted} onChange={this.onChangeTarget} label="Set all uploaded accounts to be ABM accounts"/>
              </Div>
            }
            <AccountsImportMappings onChange={this.onUpdateMappings} upload={upload} />
          </Div>
        </Div>
      </Fragment>
    )
  }
}

export default CSVImport
